// extracted by mini-css-extract-plugin
export default {"overflow-list":"OverflowList_overflow-list__5RzWw","overflow-list-spacer":"OverflowList_overflow-list-spacer__2NtR7"};